import { render, staticRenderFns } from "./TwoRowTextWithIcon.vue?vue&type=template&id=54c46dec&scoped=true"
import script from "./TwoRowTextWithIcon.vue?vue&type=script&lang=ts"
export * from "./TwoRowTextWithIcon.vue?vue&type=script&lang=ts"
import style0 from "./TwoRowTextWithIcon.vue?vue&type=style&index=0&id=54c46dec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c46dec",
  null
  
)

export default component.exports